<template lang="pug">
	.map-item_wrapper
		.map-item_container(:touch-device="TOUCH_DEVICE", :class="{ isTouchDevice: TOUCH_DEVICE, notTouchDevice: !TOUCH_DEVICE, hasSelection: selectedID !== null }")

			svg.map-item_svg(
				:width="displayWidth",
				:height="displayHeight",
				:class="{  filtered: this.filters.party, responsive: responsive, hasSelection: selectedID !== null }"
			)
				defs
					pattern(v-for="party in partiesPatterns", :id="`flip-pattern-${party.code}`" width="1" height="2" patternUnits="userSpaceOnUse" patternTransform="rotate(45 50 50)")
						rect(width="1", height="2", :fill="party.colorBright")
						line(:stroke="party.colorDark" stroke-width="1px" y2="2")


				transition(appear, name="fade")
					g.features(v-if="topojson", :key="year")
						path.electorate(
							v-for="(feature, i) in features",
							:district-id="feature.properties.ID",
							:district-name="feature.properties.NAME",
							:id="feature.properties.pathid"
							:d="feature.path",
							:style="{ fill: feature.fillColor }",
							:active="feature.properties.NAME === selectedID",
							@mouseover="!TOUCH_DEVICE && selectedID === null && showTooltip(feature.results, $event)",
							@mouseout=" !TOUCH_DEVICE && selectedID === null && hideTooltip()"
							@mousemove="!TOUCH_DEVICE && selectedID === null && moveTooltip(feature.results, $event)",
							@click="onClicked(feature, $event)"
							)
				use(:xlink:href="'#' + selectedID")

			template(v-if="options.showSearch || options.showControls")
				.ssm-map_tools(v-if="options.showControls")
					.ssm-map_tool.reset(@click="resetZoom")
						RefreshIcon
					.ssm-map_tool.zoomIn(@click="zoomIn")
						PlusIcon
					.ssm-map_tool.zoomOut(@click="zoomOut")
						MinusIcon

			.map-item-overlay( :class="{ active: showOverlayText }") {{ overlayText }}

		.map-item_tooltip(@click="tooltipClose")
			.tooltip(:style="tooltipStyles", :touch-device="TOUCH_DEVICE", :class="{ isTouchDevice: TOUCH_DEVICE, notTouchDevice: !TOUCH_DEVICE }")
				template(v-if="tooltipData")
					.tooltip_close(@click="tooltipClose")
						CloseIcon
					DistrictDataTable(:district="tooltipData", :isLive="isLive", :year="year")


</template>
<script>
import DistrictDataTable from '../DistrictDataTable/DistrictDataTable.vue';
import tooltipMixin from '../../mixins/tooltip';

import topojsonFeature from 'topojson-client/src/feature';

import { interpolate } from 'd3-interpolate';
import { geoMercator, geoPath } from 'd3-geo';
import { select, event } from 'd3-selection';
import { zoom, zoomIdentity } from 'd3-zoom/src/index';
import { rgb } from 'd3-color';

// import { path } from 'd3-path';

import quantize from 'd3-scale/src/quantize';
import threshold from 'd3-scale/src/threshold';
import linear from 'd3-scale/src/linear';

import eventTracking from '../../utils/eventTracking';

import CloseIcon from '../../assets/icon-cross.svg';
import MinusIcon from '../../assets/icon-minus.svg';
import PlusIcon from '../../assets/icon-plus.svg';
import RefreshIcon from '../../assets/icon-refresh.svg';


const normaliseElectorateName = (name = '') => name.replace(/\s/g, '_').toLowerCase();

const d3 = {
  geoMercator,
  geoPath,
  interpolate,
  select,
  scale: {
    linear,
    quantize,
    threshold
  },
  zoom,
  zoomIdentity
};

export default {
  name: 'map-item-svg',
  mixins: [ tooltipMixin ],
  props: {
    geodata: {
      type: Object,
      required: true
    },
    results: {

    },
    year: {},
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 300
    },
    initialScale: {
      type: Number,
      //default: 1525.9150802707925
    },
    centerPoint: {
      type: Array,
      default: () => [ 145.76898849997664, -19.44343762302302 ]
    },
    zoomScale: {
      type: Array,
      default: () => [ 1, Infinity ]
    },
    filters: {
      type: Object
    },
    responsive: {
      type: Boolean,
      default: false
    },
    scaleMultiplier: {
      type: Number,
      default: 1
    },
    parties: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    isLive: {
      type: Boolean,
      default: false
    },
    numInsets: {

    },
    selectedElectorate: {}
  },
  components: { DistrictDataTable, CloseIcon, MinusIcon, PlusIcon, RefreshIcon },
  data() {
    return {
      topojson: null,
      selectedID: null,
      tooltipOffset: { x: 5, y: 5 },
      tooltipData: null,
      activePath: null,
      displayWidth: 0,
      displayHeight: 0,
      isMap: true,
      currentZoomLevel: 1,
      enableZoomEvent: false,
      TOUCH_DEVICE: false,
      debug: []
    };
  },
  mounted: function() {
    this.updateBoundaries();
    this.resize();

    if (this.options.enableZoom) {
      this.initZoom();
      this.zoomEventFilter();
    }

    window.addEventListener('resize', this.resize);
    window.addEventListener('orientationchange', this.resize);

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.target && entry.target.clientWidth !== this.displayWidth) {
            console.log('resizeObserver width is different', entry.target.clientWidth, this.displayWidth);
            this.resize();
          }
        }

      });
      resizeObserver.observe(this.$el);
    } else {
      console.log('browser does not support resizeObserver');
    }

  },
  watch: {
    year(val) {
      console.log(`SVG component: Year changed to ${ val }. Update boundaries`);
      this.topojson = null;
      this.updateBoundaries();
    },
    numInsets() {
      this.resize();
    },
    selectedElectorate(newValue) {
      const electorateData = this.features.find(feature => `${ feature.properties.ID }` === newValue || `${ feature.results?.id }` === newValue);
      console.log('selectedElectorate prop change', newValue, electorateData, this.features);

      if (electorateData) {
        this.selectElectorate(electorateData);
      }
    }
  },
  computed: {
    showOverlayText() {
      return this.options.enableZoom && !this.enableZoomEvent && (!this.event || this.currentZoomLevel <= 1);
    },
    overlayText() {
      return this.TOUCH_DEVICE ? 'Pinch to zoom or use controls' : 'Hold down Shift + scroll to zoom.';
    },
    partiesPatterns() {
      return this.parties.map(party => {
        const isInd = party.code === 'IND';
        return {
          ...party,
          colorDark: isInd ? party.color : rgb(party.color).darker(0.5),
          colorBright: isInd ? rgb(party.color).brighter(1.5) : rgb(party.color).brighter(0.5),
        };
      });
    },
    partyObj() {
      return this.$store.getters.partyConfig(this.year);
    },
    boundaries() { 		return this.geodata.objects.ELECTORATE_BOUNDARIES; 	},
    svg() { 					return d3.select(this.$el).select('svg'); 					},
    featuresGroup() { return this.svg.select('g.features'); 							},
    use() { return this.svg.select('use'); 							},
    aspectRatio() { 	return this.height / this.width; 										},
    tooltip() { 			return this.$el.querySelector('.tooltip'); 					},
    path() { 					return d3.geoPath().projection(this.projection); 		},
    dimensions: {
      get: function() {
        return {
          width: this.displayWidth,
          height: this.displayHeight
        };
      },
      set: function({ width /* , height*/ }) {
        this.displayWidth = width;
        this.displayHeight = width * this.aspectRatio;
      }
    },

    features() {
      return this.topojson.features.map( (feature) => {
        const results = this.$store.getters.getDistrict(feature.properties, this.year);

        feature.properties.pathid = `electorate-path-${ normaliseElectorateName(feature.properties.NAME) }-${ this.year }`;

        return {
          ...feature,
          path: this.path(feature),
          results,
          fillColor: this.getFillColour(results),
        };
      });
    },
    projection() {
      const projection = d3.geoMercator();

      projection
        .fitSize([ this.dimensions.width * this.scaleMultiplier, this.dimensions.height * this.scaleMultiplier ], this.topojson)
        .center(this.centerPoint)
        .translate([ this.dimensions.width / 2, this.dimensions.height / 2 ]);

      if (this.initialScale) {
        // console.log('initialScale')
        projection.scale(this.initialScale);
      }

      return projection;
    },
    zoom() {
      const zoom = d3.zoom()
        .scaleExtent(this.zoomScale)
        .translateExtent([
          [ 0, -0 ],
          [ this.dimensions.width, this.dimensions.height ]
        ])
        .on('zoom', this.onZoom)
        .on('start', () => {
          this.isZooming = true;
          this.zoomEventFilter();
        })
        .on('end', () => {
          this.isZooming = false;
          this.zoomEventFilter();

          // if (this.event?.sourceEvent?.type === 'wheel') {
          if (this.selectedID) {
            const feature = this.features.find(feature => {
              return feature.properties.pathid === this.selectedID;
            });

            // console.log()

            if (feature) {
              this.showTooltip(feature.results, this.event);
            }
          }

          // }
        })
        .filter( this.zoomEventFilter );

      return zoom;
    },
    districtData: {
      // getter
      get: function() {
        return this.tooltipData;
      },
      // setter
      set: function(d) {
        console.log('districtData', d);
        this.tooltipData = d;
      }
    },
    mapClickTrackingData() {
      const analyticsConfig = this.$store.getters.getAnalyticsConfig(this.year);

      return {
        ...analyticsConfig,
        label: 'election-map-district',
        order: '1',
      };
    }
  },
  methods: {

    zoomEventFilter() {

      const numTouches = (event && event.touches && event.touches.length) || (event && event.sourceEvent && event.sourceEvent.touches && event.sourceEvent.touches.length) || 0;

      const enabled = !(
        (event && event.type === 'wheel' && !event.shiftKey) ||
					(event && event.type === 'touchstart' && numTouches <= 1 && this.currentZoomLevel <= 1 )
      );
      // console.log('showOverlayText zoomEventFilter', enabled, event, numTouches, this.currentZoomLevel, event && event.shiftKey)
      this.enableZoomEvent = enabled;
      this.svg.style('touch-action', enabled ? 'none' : 'auto');

      return this.enableZoomEvent;
    },

    getCalledSeatValue(districtData) {
      const useSplitData = this.$store.getters.currentElection(this.year).useSplitData;
      let status = '';

      if (useSplitData) {
        const statusKey = this.$store.getters.dataMasthead(this.year);

        status = (districtData.ncaCalledStatus && districtData.ncaCalledStatus[statusKey]) || '';
      } else {
        status = (districtData.ncaCalledStatus || '');
      }

      const [ , party ] = (typeof status === 'string') ? (status.match(/(.*)\s(?:gain|retain|win|likely)/i) || [] ) : [];
      const [ , win ] = (typeof status === 'string') ? (status.match(/(.*)\s(?:gain|retain|win)/i) || [] ) : [];
      return { party, isCalled: Boolean(win) };
    },

    getIsFlippedValue(incumbentCandidate, calledStatusPartyData, districtName) {
      const partyMatchArr = [].concat(
        (incumbentCandidate?.affiliation?.groupCodes || []),
        (incumbentCandidate?.affiliation?.aliasCodes || []),
        [ incumbentCandidate?.affiliation?.code ],
      );

      // console.log('isCalled', incumbentCandidate?.surname, partyMatchArr, incumbentCandidate?.affiliationGroup, calledStatusPartyData);

      if (!partyMatchArr.includes(calledStatusPartyData?.code)) {
        console.warn(`${ districtName } flipped from ${ incumbentCandidate?.surname } (${ incumbentCandidate?.affiliationGroup }) to ${ calledStatusPartyData?.code }`);
        return true;
      }
      return false;
    },

    getFillColour(districtData, baseColor = '#ddd') {
      if (!districtData) return baseColor;

      const {
        FirstPreferences: {
          Candidate: candidates
        } = {},
        TwoCandidatePreferred: {
          Candidate: twoPPcandidates
        } = {},
        ProposalResults: {
          Option
        } = {}
        // declaredPartyCode
      } = districtData;


      if (this.filters && this.filters.party) {
        const dataNode = Option || candidates;

        const filterBaseColor = '#fff';
        const partyConfig = this.partyObj[this.filters.party] || {};
        const partyMatchArr = [].concat(
          (partyConfig.groupCodes || []),
          (partyConfig.aliasCodes || []),
          [ this.filters.party ]
        );

        const
          partyData = dataNode.find( (candidate) => partyMatchArr.includes(candidate.affiliationGroup)),
          partyPercent = partyData ? parseInt(partyData.Votes.Percentage * 1, 10) / 100 : 0.01,
          maxColor = partyConfig.color || filterBaseColor;

        return d3.interpolate(filterBaseColor, maxColor)(partyPercent);

      } else {

        if (Option) {
          const
            sortedData = Option.slice().sort( (a, b) => (b.Votes.Percentage - a.Votes.Percentage) ), // b.Votes.count - a.Votes.count;
            leadingParty = sortedData[0].Votes.Percentage > 0 ? sortedData[0].affiliation.code : null,
            color = (this.partyObj[leadingParty] || {}).color;

          return color ? rgb(color).copy({ opacity: 0.4 }) : baseColor;
        }

        const
          electedCandidate = candidates.find( candidate => candidate.Elected ),
          electedParty = electedCandidate?.affiliation?.code || null,
          incumbentCandidate = candidates.find( candidate => candidate.Incumbent ),
          electedPartyColor = electedParty ? (this.partyObj[electedCandidate.affiliation.code] || {}).color : null,
          { party: calledStatusParty, isCalled } = this.getCalledSeatValue(districtData),
          calledStatusPartyData = calledStatusParty ? this.$store.getters.getPartyByCodeOrAlias(calledStatusParty, this.year) : null,
          calledPartyColor = isCalled && calledStatusPartyData ? calledStatusPartyData.color : null,
          likelyColor = !isCalled && calledStatusPartyData ? calledStatusPartyData.color : null,

          isFlipped = isCalled && incumbentCandidate ? this.getIsFlippedValue(incumbentCandidate, calledStatusPartyData, districtData.name) : false;

        if (electedPartyColor) {
          return isFlipped ? `url(#flip-pattern-${ electedParty })` : electedPartyColor;
        } else if (calledPartyColor) {
          return isFlipped ? `url(#flip-pattern-${ calledStatusParty })` : calledPartyColor;
        } else if (likelyColor) {
          return rgb(likelyColor).copy({ opacity: 0.4 });
        } else if (twoPPcandidates && twoPPcandidates.length) {

          const
            sortedData = twoPPcandidates.slice().sort( (a, b) => (b.Votes.Percentage - a.Votes.Percentage) ), // b.Votes.count - a.Votes.count;
            leadingParty = sortedData[0].Votes.Percentage > 0 ? sortedData[0].affiliation.code : null,
            color = (this.partyObj[leadingParty] || {}).color;

          if (color) return rgb(color).copy({ opacity: 0.4 });
        }

        const
          sortedData = candidates.slice().sort( (a, b) => (b.Votes.Percentage - a.Votes.Percentage) ), // b.Votes.count - a.Votes.count;
          leadingParty = sortedData[0].Votes.Percentage > 0 ? sortedData[0].affiliation.code : null,
          color = (this.partyObj[leadingParty] || {}).color;

        return color ? rgb(color).copy({ opacity: 0.4 }) : baseColor;
      }

    },

    resize() {
      this.dimensions = {
        width: this.$el.clientWidth,
        height: this.$el.clientHeight
      };
    },
    onClicked(d, e) {
      if (this.options.clickToZoomToDistrict) {
        this.selectedID = d.properties.pathid;

        console.log('asdfg');

        this.zoomToDistrict(d, e);
        this.$emit('update:selectedElectorate', `${ d.properties.ID }`);

      } else {
        this.showTooltip(d.results, e);
      }
      //tracking
      eventTracking(this.mapClickTrackingData);
    },
    updateBoundaries() {
      this.$store.commit('loading', true);
      setTimeout(() => {
        this.$store.commit('loading', true);
        this.topojson = topojsonFeature(this.geodata, this.boundaries);

        setTimeout(() => this.$store.commit('loading', false), 300);
      }, 300);
      this.resize();
    },
    resetSelection() {
      this.activePath && this.activePath.removeAttribute('active', 'active');
      this.activePath = null;
      this.selectedID = null;
      this.districtData = null;
      this.$emit('update:selectedElectorate', null);
    },
    resetZoom() {
      console.log('reset');
      if (this.activePath) {
        console.log('has active path');
        this.resetSelection();
      }

      this.svg.transition()
        .duration(300)
        .call( this.zoom.transform, d3.zoomIdentity );
    },
    initZoom() {
      this.svg.call(this.zoom);
      this.svg.style('touch-action', this.enableZoomEvent ? 'none' : 'auto');
      this.svg.on('contextmenu', function() {
        event.preventDefault();
        console.log('contextmenu');
      });
    },

    onZoom() {
      this.event = d3.event = event;

      if (this.event?.sourceEvent?.type === 'wheel' || !this.selectedID) {
        this.hideTooltip();
      }

      // console.log(this.event)

      const strokewidth = 1 / d3.event.transform.k;

      this.featuresGroup.attr('transform', d3.event.transform)
        .selectAll('path:not(.active)')
        .style('stroke-width', strokewidth + 'px' );
      this.featuresGroup.attr('transform', d3.event.transform)
        .select('path[active="active"]')
        .style('stroke-width', strokewidth * 2 + 'px' );

      this.use.attr('transform', d3.event.transform);

      this.currentZoomLevel = d3.event.transform.k;
    },
    zoomToDistrict(d, e) {

      if (this.activePath) this.activePath.removeAttribute('active', 'active');
      this.activePath = e.target;

      console.log('asdf', e.target, this.$el.querySelector(`#${ d.properties.pathid }`), d);
      this.activePath?.setAttribute('active', 'active');

      const
        bounds = this.path.bounds(d),
        dx = bounds[1][0] - bounds[0][0],
        dy = bounds[1][1] - bounds[0][1],
        x = (bounds[0][0] + bounds[1][0]) / 2,
        y = (bounds[0][1] + bounds[1][1]) / 2,
        scale = Math.max(1, Math.min(18, 0.9 / Math.max(dx / this.dimensions.width, dy / this.dimensions.height))),
        translate = [ this.dimensions.width / 2 - scale * x, this.dimensions.height / 2 - scale * y ];

      this.svg.transition()
        .duration(200)
        .call( this.zoom.transform, d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale) ); // updated for d3 v4

      setTimeout( () => {
        this.isCurrentSearch = true;
        this.showTooltip(d.results, e);
      }, 500);

      setTimeout( () => {
        this.isCurrentSearch = true;
        this.showTooltip(d.results, e);
      }, 1000);

    },
    zoomIn() {
      this.zoom.scaleBy(this.svg.transition().duration(500), 2);
    },
    zoomOut() {
      this.zoom.scaleBy(this.svg.transition().duration(500), 0.5);
    },

    selectElectorate(electorate) {
      const
        el = this.$el.querySelector(`#${ electorate.properties.pathid }`);

      console.log('selectElectorate', el, electorate.properties.pathid, this.$el);
      if (this.$el.scrollIntoViewIfNeeded) {
        this.$el.scrollIntoViewIfNeeded(false);
      }


      this.selectedID = electorate.properties.pathid;
      this.zoomToDistrict(electorate, { target: el });

      el.dispatchEvent(new Event('click'));
    },
    tooltipClose() {
      this.hideTooltip();
      this.resetSelection();

      this.isCurrentSearch = false;
    }
  }
};
</script>
<style lang="scss">
	@import "src/core/scss/global-sass";

	.map-item_container {
		position: relative;
		// border: 2px solid #ff0000;

		&.hasSelection {
			path:not([active]) { opacity: 0.5; }

			+ .map-item_tooltip {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				// background: rgba(255,255,255,0.8);

				// @include MQ_MediumLarge {
				// 	min-width: 400px;
				// }

				div.tooltip {
					// left: 50% !important;
					// top: 50% !important;
					// transform: translate(-50%, -50%);
					// transform: translate3d(-50%, -50%, 0);
					@include MQ_TabletAndUp {
						position:relative;
						left: initial !important;
						top: initial !important;
						transform: initial !important;
						min-width: 100%;
					}
					// position:relative;


					// max-height: 100%;
					// max-height: calc(100% - #{$m-spacing * 2});
					overflow-y: auto;

					@include MQ_MobileOnly() {
						// max-height: calc(100vh - #{$m-spacing * 2});
            height: auto;
					}

					&,
					* {
						pointer-events:all;
					}

					&.visible {
						opacity: 1 !important;
					}

					// .district-results_table .tr {
					// 	border-bottom-width: 8px;
					// 	margin-bottom: -1px;
					// }
				}
			}
		}
	}

	.map-inset {
		// display:inline-block;
		text-align: center;

		svg.map-item_svg {
			overflow: hidden;
			background-color: #eee;
			border-radius: 100%;

			&:not(.filtered) path {
				stroke-width: 1.0px;
				stroke: #fff;
			}

			&.filtered {
				border: 1px solid rgba(0,0,0,0.5)
			}
		}
	}

	.map-item-overlay {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50% );
		background: rgba(255,255,255,0.2);
		padding: 3px 1em;
		// padding: 0 1em;
		display: flex;
		align-items: center;
		justify-content: center;
		pointer-events: none;
		transition: opacity 0.2s ease;
		opacity: 0;
		border-radius: 2px;
		color: #fff;

		&.active {
			opacity: 1;
		}

		.map-inset & {
			display: none;
		}
	}

	.map-item_svg {
		// outline: 1px solid red;

		.screenkit--embed-container & {
			// border: 2px solid red;
			min-height: 200px;
		}

		&.responsive {
			width: 100%;
		}

		path.electorate {
			stroke-width: 1px;
			stroke: rgba(255,255,255,0.8);
			fill: #999;
			cursor: pointer;
			transition: opacity 0.3s, fill 0.3s ease;
			&[active="active"] {

				stroke-miterlimit: 0.3;
				stroke: #000;
				stroke-dasharray: 2500;
				stroke-dashoffset: 2500;
				animation: dash 1s 0.4s ease-in-out forwards;
			}
		}

		&.filtered path { stroke: rgb(24, 8, 8); }

		path:not(.active):hover {
			opacity: 0.8;
		}
		path {
			// cursor: zoom-in;

			&.active {
				// cursor: zoom-out;
			}
		}


	}

	.map-item_tooltip {

	}

@keyframes dash {
	from {
		stroke-dashoffset: 2500;
	}
	to {
		stroke-dashoffset: 0;
	}
}


	.ssm-map {
		/**
		TOOLS
		**/

		&_tools {
				position: absolute;
				right: 0;
				top: 0;
				// padding: 6px 12px 12px;
				margin: 6px;
				// background: rgba(255,255,255,1);
			transition: right 0.3s;
		}
		@include MQ_SmallMedium() {
			&.breakdown-visible &_tools {
				right: 329px;
			}
		}
		@include MQ_LargeOnly() {
			.ssm-fullscreen &.breakdown-visible &_tools {
				right: 329px;
			}
		}

		.ssm-results_search_main {
			display: none;
		}


		&_tool {
			padding: 6px;
			border: 1px solid currentColor;
			margin-top: 6px;
			cursor: pointer;
			max-height: 36px;
			width: 36px;
			background: #fff;
			margin: 6px;

			&:first-child { margin-top:0; }

			&,
			* { box-sizing: border-box; }

			svg {
				width: 100%;
			}

			path {
				fill: currentColor
			}

			&.active,
			&:hover {
				color: #19acf0;
			}
			text {display: none;}

			&.zoomIn {
				canvas { width: 100%; }
			}
		}

	}


</style>
